import React, { useState, useEffect } from 'react';
import {TextField, Box} from '@mui/material';

const JsonPathInput = props => {
    const [value, setValue] = useState('');
    useEffect(() => {
        if(props.value){
            setValue(props.value)
        } else {
            setValue('')
        }
    }, [props.value])
    return (
        <TextField label={props.label} value={value} onChange={props.onChange} />
    );
};

export default JsonPathInput;
